import React, { useEffect } from 'react';
import {
  CssBaseline,
  ThemeProvider
} from '@mui/material';
import Header from "../src/containers/Header/header"
import Frame from './containers/Frame/Frame';
import NotFound from './containers/NotFound/NotFound';
import { defaultTheme, nextBetThemeWithFonts } from './theme/theme';
import AutoSignIn from '../src/containers/AutoSignIn/AutoSignIn'
import { getUrlParam } from './utils/common';
import { decodeMParam } from './utils/jwtUtils';
import Call from '../src/containers/Call/call';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

interface AppProps {
  brand: string; // Accept brand as prop
  lang: string;  // Accept lang as prop
}

const usePageMetadata = (brand: string, lang: string) => {
  useEffect(() => {
    const pageTitle = brand?.toLowerCase() === "nextbet" ? "Nextbet Mobile Chat" : "Dafabet Mobile Chat";
    document.title = pageTitle;

    let faviconUrl = brand?.toLowerCase() === "nextbet" 
      ? "/mobile/nextbet_favicon.ico" 
      : "/mobile/dafabet_favicon.ico";

      if (brand?.toLocaleLowerCase() == 'nextbet' && lang.toLocaleLowerCase() === 'pt') {
        faviconUrl = "/mobile/nextbetpt_favicon.ico";
      }

    const favicon = document.getElementById("dynamic-favicon") as HTMLLinkElement;

    if (favicon) {
      favicon.href = faviconUrl;
    }
  }, [brand]);
};

function App({ brand, lang }: AppProps) {
  const location = useLocation();
  
  // Get and decode the m parameter
  const encryptedMParam = getUrlParam('m');
  let mParam = null;
  let mUsername = null;
  let mEmail = null;
  let mReferer = null;
  
  // Only try to decode if m parameter exists
  if (encryptedMParam) {
    try {
      const decodedData = decodeMParam(encryptedMParam);
      if (decodedData) {
        mParam = decodedData.msg || null;
        mUsername = decodedData.username || null;
        mEmail = decodedData.email || null;
        mReferer = decodedData.referer || null;
      }
    } catch (error) {
      console.error('Error processing m parameter:', error);
    }
  }
  
  // Determine if this is a proactive chat
  const isProactive = Number(getUrlParam('proactive')) === 1 || encryptedMParam !== null;
  
  usePageMetadata(brand || "dafabet", lang || "en");
  const isNextBet = brand?.toLowerCase() === 'nextbet';
  let theme = isNextBet ? nextBetThemeWithFonts : defaultTheme;

  if (isNextBet && lang.toLocaleLowerCase()==='pt') {
    theme = defaultTheme;
  }

  const isNotFound = location.pathname === "*";
  
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {!isNotFound && <Header />} {/* Conditionally render Header */}
      <Routes>
        <Route path='/mobile/call/:brand' element={<Call />} />
        <Route 
          path="/mobile/:language/:brand" 
          element={
            isProactive ? (
              <AutoSignIn 
                mParam={mParam} 
                mUsername={mUsername} 
                mEmail={mEmail} 
                mReferer={mReferer} 
              />
            ) : (
              <Frame />
            )
          } 
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
